import { Tooltip } from 'antd'
import isNil from 'lodash-es/isNil'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import Blur from '@/components/common/blur'
import { I18nId } from '@/i18n/config'
import { useIntl } from '@/i18n/hooks/use-intl'
import { Nullable } from '@/types/nullable'
import { RatingInfo } from '@/utils/kol/evaluate-metric-pr'

interface MetricTooltipProps {
  pr?: RatingInfo
  performancePr50?: Nullable<number>
  hiddenData: boolean
  metricTypeI18nId: I18nId
}

const MetricPrTooltip: FunctionComponent<MetricTooltipProps> = ({
  hiddenData,
  pr,
  performancePr50,
  metricTypeI18nId,
}) => {
  const { formatMessage, formatNumber } = useIntl()

  if (isNil(pr) || isNil(performancePr50)) {
    return null
  }

  return (
    <Tooltip
      placement='bottom'
      title={
        !hiddenData && (
          <TooltipContent $hiddenData={hiddenData}>
            {formatMessage(
              { id: 'kol:platform_performance_chart_pr50' },
              {
                metricType: formatMessage({
                  id: metricTypeI18nId,
                }),
                span: (text) => <span>{text}</span>,
                pr50: formatNumber(performancePr50, {
                  isPercentageDisplay: true,
                }),
              },
            )}
          </TooltipContent>
        )
      }
    >
      <MetricPerformance $color={pr.color}>
        <Blur activate={hiddenData}>{formatMessage({ id: pr.rating })}</Blur>
      </MetricPerformance>
    </Tooltip>
  )
}

export default MetricPrTooltip

const MetricPerformance = styled.div<{ $color: string }>`
  color: ${({ $color }): string => $color};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  align-self: flex-end;
  line-height: 140%;
`

const TooltipContent = styled.div<{ $hiddenData: boolean }>`
  span {
    filter: blur(${({ $hiddenData }): string => ($hiddenData ? '5px' : '0')});
  }
`
